import { Typography } from "antd";
import { DrawerCollapsible, DrawerCollapsibleProps } from "components/UI/DrawerCollapsible/DrawerCollapsible.tsx";
import { FC, ReactNode } from "react";

import "./sub-collapsible-overrides.css";

interface Props extends Omit<DrawerCollapsibleProps, "title" | "wrapperClassName"> {
    title: string | ReactNode;
}

export const DrawerSubCollapsible: FC<Props> = ({ title, ...props }) => (
    <DrawerCollapsible
        wrapperClassName={"!p-0"}
        title={
            <Typography.Title className={"!m-0"} level={5}>
                {title}
            </Typography.Title>
        }
        {...props}
    />
);
